module.exports = __webpack_public_path__ + "static/follow-us-45f5d24bf2d77e486dbb6068f2bf7293.svg";